// Define common properties
const commonPermissions = {
  add: false,
  edit: false,
  view: false,
  shownView: true,
  shownAdd: false,
  shownEdit: false
}

// Define individual manager permissions by extending commonPermissions
const Permission = [
  { manager: 'company_manager', ...commonPermissions },
  { manager: 'earning-managers', ...commonPermissions },
  {
    manager: 'category-subcategory-manager',
    ...commonPermissions,
    shownAdd: true,
    shownEdit: true
  },
  {
    manager: 'company_specific-dashboard',
    ...commonPermissions,
    shownAdd: true,
    shownEdit: true
  },
  {
    manager: 'city_manager',
    ...commonPermissions,
    shownAdd: true,
    shownEdit: true
  },
  {
    manager: 'state_manager',
    ...commonPermissions,
    shownAdd: true,
    shownEdit: true
  },
  { manager: 'forms-manager', ...commonPermissions },
  {
    manager: 'country_manager',
    ...commonPermissions,
    shownAdd: true,
    shownEdit: true
  },
  { manager: 'notification_manager', ...commonPermissions, shownAdd: true },
  {
    manager: 'reports',
    view: false,
    shownView: true
  },
  {
    manager: 'static-page-management',
    ...commonPermissions,
    shownAdd: true,
    shownEdit: true
  },
  { manager: 'faqs', ...commonPermissions, shownAdd: true, shownEdit: true },
  {
    manager: 'subscription_manager',
    ...commonPermissions,
    shownAdd: true,
    shownEdit: true
  },
  { manager: 'support_manager', ...commonPermissions },
  {
    manager: 'banner-management',
    ...commonPermissions,
    shownAdd: true,
    shownEdit: true
  },
  { manager: 'settings', ...commonPermissions }
]

export default Permission
